import React, { useState } from "react";
import "./proshopcard.css";

const SHOP_URL = "https://shop.cosmetink.com";
const DISCOUNT_CODE = "cosmetinkalumni";

const ProShopCard = () => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(DISCOUNT_CODE);
      setCopied(true);
      setTimeout(() => setCopied(false), 1100);
    } catch (err) {
      console.error("Clipboard failed:", err);

      // fallback (older browsers / some mobile cases)
      try {
        const input = document.createElement("input");
        input.value = DISCOUNT_CODE;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);

        setCopied(true);
        setTimeout(() => setCopied(false), 1100);
      } catch (e2) {
        alert("Copy failed — please manually type: cosmetinkalumni");
      }
    }
  };

  return (
    <a
      className="dash-proshop-card"
      href={SHOP_URL}
      target="_blank"
      rel="noreferrer"
    >
      <div className="dash-proshop-top">
        <div className="dash-proshop-badge">ALUMNI PERK ✦</div>
        <div className="dash-proshop-title">COSMETINK PRO Shop</div>
        <div className="dash-proshop-sub">Where the pros shop ✨</div>
      </div>

      <div className="dash-proshop-mid">
        <div className="dash-proshop-perk">
          <div className="dash-proshop-perk-label">Student code</div>

          <div className="dash-proshop-code-row">
            <button
              type="button"
              className="dash-proshop-code-btn"
              onClick={handleCopy}
              aria-label="Copy discount code"
              title="Tap to copy"
            >
              <span className="dash-proshop-code">{DISCOUNT_CODE}</span>
              <span className={`dash-proshop-copied ${copied ? "is-on" : ""}`}>
                Copied!
              </span>
            </button>

            <span className="dash-proshop-off">10% OFF</span>
          </div>

          <div className="dash-proshop-hint">Tap to copy • Use at checkout</div>
        </div>

        <div className="dash-proshop-bullets">
          <div className="dash-proshop-bullet">🎨 Pigments that heal beautifully</div>
          <div className="dash-proshop-bullet">🧤 Supplies you’ll actually love</div>
          <div className="dash-proshop-bullet">⚡ Machines that help you stand out</div>
        </div>
      </div>

      <div className="dash-proshop-cta">
        <span>Shop now</span>
        <span className="dash-proshop-arrow">→</span>
      </div>
    </a>
  );
};

export default ProShopCard;
